import { ColorPickerField } from '../../components/ColorPickerField';
import { ImageUploader } from '../../components/ImageUploader';

const rankPortalTextEditorPlugin = (fn: any) => {
  return {
    Renderer: ({ data }: any) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="rank-portal-list-outer"
        >
          <div
            style={{
              margin: '5px 10px',
              padding: '20px 30px',
              fontSize: '20px',
              borderRadius: '50px',
              overflowWrap: 'anywhere',
              width: 280,
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: data?.backgroundColor
                ? data?.backgroundColor
                : 'rgba(204,204,204,1)',
            }}
            className="rank-portal-list-container"
          >
            <img
              style={{ width: '100%', display: 'block', margin: '0 auto' }}
              src={data?.imageUrl ? data?.imageUrl : ''}
            />
          </div>
        </div>
      );
    },
    id: 'rankPortalRTE',
    title: 'Rank Portal Image',
    version: 1,
    controls: {
      type: 'autoform',
      columnCount: 1,
      schema: {
        properties: {
          backgroundColor: {
            type: 'string',
            default: '#F2F2F2',
            uniforms: {
              component: ColorPickerField,
              label: 'Background Color: ',
            },
          },

          imageUrl: {
            type: 'string',
            default: '',
            uniforms: {
              component: ImageUploader,
              label: 'Image Upload: ',
              imageUpload: fn,
            },
          },
        },
      },
    },
  };
};

export default rankPortalTextEditorPlugin;
